@if (poll) {
  <div class="sp" [class.is-results]="poll.results_visible" role="group" aria-label="Poll">
    @for (option of poll.options; track option.id) {
      <button
        type="button"
        class="sp-option"
        [class.is-mine]="poll.my_vote === option.id"
        [disabled]="voting || poll.is_closed"
        [attr.aria-pressed]="poll.my_vote === option.id"
        (click)="vote(option)">
        @if (poll.results_visible) {
          <span class="sp-bar" [style.width.%]="percent(option)"></span>
        }
        <span class="sp-text">
          @if (poll.my_vote === option.id) {
            <i class="fa fa-check-circle" aria-hidden="true"></i>
          }
          {{ option.text }}
        </span>
        @if (poll.results_visible) {
          <span class="sp-pct">{{ percent(option) }}%</span>
        }
      </button>
    }
    <p class="sp-foot">
      {{ footer }}
      @if (!poll.results_visible && !poll.is_closed) {
        <span> · Vote to see the results</span>
      }
    </p>
    @if (error) {
      <p class="sp-error" role="alert">{{ error }}</p>
    }
  </div>
}
